/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { trackedTask } from 'reactiveweb/ember-concurrency';

import phorestLogo from 'my-phorest/assets/images/phorest-logo-electron.svg';
import refreshIcon from 'my-phorest/assets/images/status-bar-refresh.svg';
import collapseIcon from 'my-phorest/assets/images/status-bar-collapse.svg';
import { registerDestructor } from '@ember/destroyable';
import { tracked } from '@glimmer/tracking';

export default class PageTitleBarComponent extends Component {
  @service branchSettings;
  @service('browser/window') window;
  @service electronApp;
  @service eventPropagator;
  @service intl;
  @service notifications;
  @service platform;
  @service sidebar;

  phorestLogoSrc = phorestLogo;
  refreshIconSrc = refreshIcon;
  collapseIconSrc = collapseIcon;

  @tracked isFullscreen = false;

  appVersion = trackedTask(this, this.getElectronAppVersionTask, () => []);

  constructor() {
    super(...arguments);
    this.listenForFullscreenChanges();
  }

  get isSidebarOpen() {
    return this.sidebar.isOpen;
  }

  get showTitleBar() {
    return (
      this.electronApp.isRunningInElectron && this.electronApp.hasCustomTitleBar
    );
  }

  get isWindows() {
    return this.platform.isWindows;
  }

  get appColor() {
    return this.branchSettings.appColor;
  }

  get isThemeColorDark() {
    return this.branchSettings.isThemeColorDark;
  }

  @action
  handleFullscreenChanged(isFullscreen) {
    this.isFullscreen = isFullscreen;
  }

  @action
  refresh() {
    this.window.location.reload(true);
  }

  @action
  toggleSidebar() {
    this.sidebar.toggleSidebar();
  }

  @action
  copyVersionToClipboard() {
    this.window.navigator.clipboard
      .writeText(this.appVersion.value)
      .then(() => {
        this.notifications.success(
          this.intl.t('global.copied'),
          this.intl.t('titlebar.version-copied-to-clipboard')
        );
      })
      .catch(() => {
        console.error('Could not copy app version to clipboard');
      });
  }

  @task
  *getElectronAppVersionTask() {
    return yield this.electronApp.getVersion();
  }

  async listenForFullscreenChanges() {
    this.isFullscreen = await this.electronApp.isFullscreen();

    this.eventPropagator.subscribe(
      'fullscreenChanged',
      this.handleFullscreenChanged
    );
    registerDestructor(this, () => {
      this.eventPropagator.unsubscribe(
        'fullscreenChanged',
        this.handleFullscreenChanged
      );
    });
  }
}
